import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/PressContacts.css';

const PressContacts = () => {
  return (
    <>
      <Helmet>
        <title>Press Contacts - Media Relations & Inquiries | Redbox Global</title>
        <meta name="description" content="Contact Redbox Global's media relations team for press inquiries, interview requests, media kits, and expert commentary on financial markets, data services, and technology innovation." />
        <meta name="keywords" content="press contacts, media relations, press inquiries, media contact, journalist resources, press office, media team, spokesperson, interview requests, Redbox Global media, press releases, media kit" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/press-contacts" />
        <meta property="og:title" content="Press Contacts - Media Relations | Redbox Global" />
        <meta property="og:description" content="Connect with Redbox Global's media relations team for press inquiries, interviews, and expert commentary." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/press-contacts" />
        <meta name="twitter:title" content="Press Contacts - Media Relations | Redbox Global" />
        <meta name="twitter:description" content="Contact Redbox Global's media relations team for press inquiries and expert commentary." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/press-contacts" />
        <meta name="contact" content="press@redboxglobal.com" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Press Contacts",
            "description": "Contact information for Redbox Global media relations and press inquiries.",
            "url": "https://redboxglobal.com/press-contacts",
            "mainEntity": {
              "@type": "Organization",
              "name": "Redbox Global",
              "url": "https://redboxglobal.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              },
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "telephone": "+1-212-318-2000",
                  "contactType": "Media Relations",
                  "areaServed": "US",
                  "availableLanguage": ["English"]
                },
                {
                  "@type": "ContactPoint",
                  "telephone": "+44-20-7330-7500",
                  "contactType": "Media Relations",
                  "areaServed": "GB",
                  "availableLanguage": ["English"]
                },
                {
                  "@type": "ContactPoint",
                  "telephone": "+65-6212-1000",
                  "contactType": "Media Relations",
                  "areaServed": "SG",
                  "availableLanguage": ["English"]
                }
              ],
              "email": "press@redboxglobal.com"
            }
          })}
        </script>
      </Helmet>
      
         <div className="page-container">
        <div className="page-header">
          <h1>Redbox Press Contacts</h1>
          <p className="page-subtitle">
            Get in touch with our media and PR team for inquiries and interviews
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/press-contact-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=600&fit=crop"
                  alt="Redbox press contacts"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Press Overview</span> */}
                <h2>Connect with Redbox Global's Press & Media Team</h2>
                <p>
                  Our press team is ready to assist with media inquiries, interviews, and official
                  statements. Reach out for accurate and timely information about Redbox Global.
                </p>
                <span className="article-meta">Contact Press Team</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/press-contact-1"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop"
                    alt="Press contact 1"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">PR Manager</span> */}
                  <h2>Jane Doe</h2>
                  <p>Email: jane.doe@redboxglobal.com | Phone: +1 234 567 8901</p>
                  <span className="article-meta">Contact Jane</span>
                </div>
              </article>
            </a>

            <a
              href="/article/press-contact-2"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&h=400&fit=crop"
                    alt="Press contact 2"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Media Relations</span> */}
                  <h2>John Smith</h2>
                  <p>Email: john.smith@redboxglobal.com | Phone: +1 234 567 8902</p>
                  <span className="article-meta">Contact John</span>
                </div>
              </article>
            </a>

            <a
              href="/article/press-contact-3"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1519337265831-281ec6cc8514?w=600&h=400&fit=crop"
                    alt="Press contact 3"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Communications</span> */}
                  <h2>Mary Johnson</h2>
                  <p>Email: mary.johnson@redboxglobal.com | Phone: +1 234 567 8903</p>
                  <span className="article-meta">Contact Mary</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PressContacts;
